import React from "react";
import styles from "./topDonorCardUser.module.scss";
import { TUserData } from "../../../../stores/EventStore";
import { get_city_label } from "../../../../utils/misc";
import { SHORT_BLOOD_GROUPS, User } from "../../../../entities";

type TTopDonorCardUser = {
  user: TUserData;
};

export const TopDonorCardUser: React.FC<TTopDonorCardUser> = ({ user }) => {
  return (
    <div className={styles.TopDonorUserDataCard}>
      <div className={styles.TopDonorUserDataCard_UserData}>
        <div className={styles.TopDonorUserDataCard_UserData_Avatar}>
          <TopDonorUserAvatar user={user} />
        </div>
        <TopDonorUserBloodType user={user} />
      </div>
      <div className={styles.TopDonorUserDataCard_UserText}>
        <div className={styles.TopDonorUserDataCard_UserText_Name}>
          <span>
            {[user.first_name, user.last_name].filter(Boolean).join(" ")}
          </span>
        </div>
        <div className={styles.TopDonorUserDataCard_UserText_City}>
          <span>{get_city_label(user.city)}</span>
          <span data-mobile={true}>{user.city?.title}</span>
        </div>
      </div>
    </div>
  );
};

type TTopDonorUserBloodType = {
  user: User;
};

const TopDonorUserBloodType: React.FC<TTopDonorUserBloodType> = ({ user }) => {
  if (!user?.blood_group)
    return (
      <div className={styles.TopDonorUserBloodType} data-shadow={false}>
        <span>
          <br />
        </span>
      </div>
    );
  return (
    <div className={styles.TopDonorUserBloodType}>
      <span>{SHORT_BLOOD_GROUPS[user?.blood_group]}</span>
    </div>
  );
};

type TTopDonorUserAvatar = {
  user: User;
};

const TopDonorUserAvatar: React.FC<TTopDonorUserAvatar> = ({ user }) => {
  if (user.photo) {
    return (
      <div className={styles.TopDonorUserAvatar}>
        <img src={user.photo?.small} alt="UserPhoto" />
      </div>
    );
  } else {
    return (
      <div className={styles.TopDonorUserAvatar}>
        <img
          src="/static/images/icons/defaultUserAvatar.svg"
          alt="default User photo"
        />
      </div>
    );
  }
};

export default TopDonorCardUser;
